export var IntegrationSecretsLocation;
(function (IntegrationSecretsLocation) {
    IntegrationSecretsLocation["CLOUD"] = "cloud";
    IntegrationSecretsLocation["CONNECTOR"] = "connector";
})(IntegrationSecretsLocation || (IntegrationSecretsLocation = {}));
//# sourceMappingURL=integration-secrets-location.enum.js.map